import { jsxs as t, jsx as a } from "react/jsx-runtime";
const r = () => /* @__PURE__ */ t("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 801.139 220.579", children: [
  /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a("clipPath", { id: "a", children: /* @__PURE__ */ a("rect", { width: "801.139", height: "220.579", fill: "none" }) }) }),
  /* @__PURE__ */ t("g", { clipPath: "url(#a)", children: [
    /* @__PURE__ */ a(
      "path",
      {
        className: "logo--letter logo--leter__o",
        d: "M162.027,78.552A73.26,73.26,0,1,1,87.645,6.43H88.5a72.446,72.446,0,0,1,73.519,71.36c.011.261.011.511.011.761m-116.351.284a43,43,0,0,0,85.925,3.7c.045-1.238.045-2.477,0-3.7A43.025,43.025,0,1,0,45.677,74.2a45.053,45.053,0,0,0,0,4.635",
        transform: "translate(160.757 67.851)",
        fill: "#d2190e"
      }
    ),
    /* @__PURE__ */ a(
      "path",
      {
        d: "M152.207,127.909V202.28a14.77,14.77,0,0,1-29.539,0V132.135a29.385,29.385,0,0,0-30.141-32.118,30.672,30.672,0,0,0-31.573,29.755c-.023.784-.023,1.579.023,2.363V202.28A14.37,14.37,0,0,1,47.49,217.47c-.386.023-.773.034-1.159.023a14.777,14.777,0,0,1-14.94-14.6c0-.2,0-.409.011-.613V15.217A14.757,14.757,0,0,1,45.718.015c.2-.011.409-.011.614-.011A14.365,14.365,0,0,1,61,14.058c.011.386,0,.773-.023,1.159V89.872a52.2,52.2,0,0,1,40-16.906c30.993,0,51.273,21.689,51.273,54.932",
        transform: "translate(325.25 3.273)",
        fill: "#161615"
      }
    ),
    /* @__PURE__ */ a(
      "path",
      {
        d: "M84.928,19.629A19.872,19.872,0,1,1,64.353.485c.284-.011.568-.011.852-.011A19.484,19.484,0,0,1,84.928,19.629M50.288,197.4V83.3a14.77,14.77,0,1,1,29.539,0V197.4a14.766,14.766,0,0,1-14.315,15.213H64.9a14.515,14.515,0,0,1-14.656-14.372c0-.284,0-.568.011-.841",
        transform: "translate(468.296 7.802)",
        fill: "#161615"
      }
    ),
    /* @__PURE__ */ a(
      "path",
      {
        d: "M91.3,19.629A19.872,19.872,0,1,1,70.725.485c.284-.011.568-.011.852-.011A19.484,19.484,0,0,1,91.3,19.629M56.649,197.4V83.3a14.77,14.77,0,1,1,29.539-.125V197.4a14.766,14.766,0,0,1-14.315,15.213h-.614A14.508,14.508,0,0,1,56.6,198.239c0-.284,0-.568.011-.841",
        transform: "translate(534.318 7.802)",
        fill: "#161615"
      }
    ),
    /* @__PURE__ */ a(
      "path",
      {
        d: "M204.12,78.552A73.255,73.255,0,1,1,129.738,6.43h.852a72.463,72.463,0,0,1,73.53,71.36v.761M87.77,78.836a43,43,0,0,0,85.925,3.7c.057-1.238.057-2.477,0-3.7A43.025,43.025,0,1,0,87.77,74.2a45.046,45.046,0,0,0,0,4.635",
        transform: "translate(597.007 67.851)",
        fill: "#161615"
      }
    ),
    /* @__PURE__ */ a(
      "path",
      {
        d: "M146.5,145.425A72.438,72.438,0,0,0,72.98,74.065h-.852A72.9,72.9,0,0,0,30,88.267V11.544C30,4.92,23.808,0,15.356,0,6.63,0,.427,4.92.427,11.544v128.3a71.917,71.917,0,0,0-.42,8.612,73.261,73.261,0,1,0,146.5-2.284c0-.25,0-.5-.011-.75m-30.414,4.738a43,43,0,0,1-85.925-3.692,45.058,45.058,0,0,1,0-4.635,43.025,43.025,0,1,1,85.925,4.635c.045,1.227.045,2.465,0,3.692",
        transform: "translate(-0.007 0.272)",
        fill: "#161615"
      }
    )
  ] })
] });
export {
  r as default
};
